import type { CalendarResponse, ObjectApartmentSummary } from '@/shared/api';
import { BookingReassignmentDialog } from '@/features/bookings/reassignment';
import { familyRefusals } from './calendarFamily';
import type { CalendarReassignmentRequest } from './calendarReassignment';

interface Props {
  request: CalendarReassignmentRequest;
  apartments: ObjectApartmentSummary[];
  calendar: CalendarResponse | undefined;
  onClose: () => void;
}

/**
 * „Apartment wechseln“ aus dem Belegungskalender. Was der Kalender schon als durch den
 * Wohnungsverbund belegt zeigt, bietet der Dialog gar nicht erst als Ziel an.
 */
export function CalendarReassignmentDialog({ request, apartments, calendar, onClose }: Props) {
  const source = apartments.find((item) => item.id === request.sourcePropertyId);
  return (
    <BookingReassignmentDialog
      open
      onOpenChange={(open) => !open && onClose()}
      bookingId={request.bookingId}
      sourcePropertyId={request.sourcePropertyId}
      sourcePropertyName={source?.adminDisplayName ?? source?.name ?? 'Aktuelles Apartment'}
      checkInDate={request.span.checkInDate}
      checkOutDate={request.span.checkOutDate}
      properties={apartments}
      initialTargetPropertyId={request.targetPropertyId || null}
      unavailableTargets={
        calendar
          ? familyRefusals(calendar.properties, request.sourcePropertyId, request.span)
          : undefined
      }
    />
  );
}
